import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const COLLECTIONS_ENABLED_FIELD = 'settings.collectionsEnabled';
export const COLLECTIONS_SECTION_TEST_ID = 'collections-setting-section';
export const COLLECTIONS_ENABLED_CHECKBOX_TEST_ID = 'collections-enabled';

export type CollectionsSettingSectionProps = SiteSettingsForSiteAdminProps<'collectionsEnabled'>;

export function CollectionsSettingSection(): React.ReactElement {
  return (
    <SettingsSection
      description={Messages.collectionsSiteSettingDescription()}
      title={Messages.collections()}
      testId={COLLECTIONS_SECTION_TEST_ID}>
      <FormikCheckbox
        label={Messages.collectionsSiteSettingLabel()}
        name={COLLECTIONS_ENABLED_FIELD}
        testId={COLLECTIONS_ENABLED_CHECKBOX_TEST_ID}/>
    </SettingsSection>
  );
}

export const CollectionsSettingSectionSpecs = componentRegistryEntry({
  name: 'CollectionsSettingSection',
  component: CollectionsSettingSection
});